import React from "react";
import "./submenuMob.scss";
import { ImDatabase } from "react-icons/im";
import { SiGoogleanalytics } from "react-icons/si";
import { AiFillClockCircle } from "react-icons/ai";

import { SubMenuLink } from "../subSolutions"
import { useTranslation } from "react-i18next";


export default function SubMenuProdutosMob() {

  const { t } = useTranslation()

  return (
    <div className="container-submenuProdMob">
      <div className="submenu-ProdMob">
        <div className="dados-conectoresMob">
          <div className="title-dadosconectoresMob">
            <h1>
              <ImDatabase /> {t("navbar.produtos_menu.connectors.title")}
            </h1>
          </div>

          <SubMenuLink link="/connectors" text={t("navbar.produtos_menu.connectors.conectors_link_text")} />
          <SubMenuLink link="/dataSources" text={t("navbar.produtos_menu.connectors.datasources_link_test")} />
          <SubMenuLink link="/dataManagement" text={t("navbar.produtos_menu.connectors.datamanagement_link_test")} />
          <SubMenuLink link="/realtimeData" text={t("navbar.produtos_menu.connectors.realdata_link_test")} />
        </div>
        <div className="dash-relatorioMob">
          <div className="title-dashMob">
            <h1>
              <SiGoogleanalytics /> {t("navbar.produtos_menu.dashboards_and_reports.title")}
            </h1>
          </div>
          <SubMenuLink link={"/InteractiveDashboards"} text={t("navbar.produtos_menu.dashboards_and_reports.interactive_dashboard.title")} />
          <SubMenuLink link={"/Reports"} text={t("navbar.produtos_menu.dashboards_and_reports.mobile_dashboards.title")} />
          <SubMenuLink link={"/WhiteLabel"} text="White Label/OEM" />
          <SubMenuLink link={"/AgileDashboards"} text={t("navbar.produtos_menu.dashboards_and_reports.dashboard_design.title")} />
        </div>
        <div className="automacaoMob">
          <div className="title-automacaoMob">
            <h1>
              <AiFillClockCircle />  {t("navbar.produtos_menu.automation.title")}
            </h1>
          </div>
          <a href="/publishAndShare">
            <p>{t("navbar.produtos_menu.automation.publish_and_share.title")}</p>
          </a>
          <a href="/scheduling">
            <p>{t("navbar.produtos_menu.automation.scheduling.title")}</p>
          </a>
          <a href="/securityandmanagement">
            <p>{t("navbar.produtos_menu.automation.security_and_management.title")}</p></a>
          <a href="/advancedSecurity">
            <p>{t("navbar.produtos_menu.automation.advanced_security.title")}</p>
          </a>
        </div>
      </div>
    </div>
  );
}
